<div class="child-list">
  <ng-container *ngIf="loaded$ | async; else loading">
    <ng-container *ngIf="children$ | async as children">
      <div class="child-count text-white bg-primary rounded mt-lg-4 d-flex justify-content-between p-3 mb-3">
        <div class="child-list-title d-flex">
          <h3 class="heading-text">{{ 'kids.page.childadded' | translate }}</h3>
          <span class="heading-text length-num ms-3">{{ children.data?.length }}/{{ children.limit }}</span>
        </div>
        <div class="button-wrapper" [class.w-upgrade]="children.free?.length > 0">
          <!-- Upgrade Kids -->
          <div
            class="btn btn-white btn-upgrade-kids my-auto p-0 d-flex align-items-center justify-content-center cursor-pointer border-white"
            (click)="upgradeChildren()"
            *ngIf="children.free?.length > 0"
          >
            <span class="material-symbols-outlined text-primary me-2">arrow_circle_up</span>
            <span class="text-primary upgrade-kid fw-bold">{{ 'guardian.button.upgrade' | translate }}</span>
          </div>
          <!--Add kids-->
          <div
            class="btn btn-primary btn-add-kids align-items-center justify-content-center d-flex cursor-pointer mr-lg-3"
            [routerLink]="['/register/newchildren']"
            *ngIf="children.data?.length < children.limit"
          >
            <span class="material-icons-outlined me-2"> add_circle </span>
            <span
              class="mr-auto add-kid fw-bold child-add-button"
              [innerHTML]="'child.list.add.button.text' | translate | markdownTranslate"
            ></span>
          </div>
        </div>
      </div>
      <div *ngIf="children.data?.length">
        <div>
          <owl-carousel-o [options]="customOptions">
            <ng-template *ngFor="let child of children.data" carouselSlide [width]="301">
              <div class="mb-1">
                <fgb-child-panel [child]="child"></fgb-child-panel>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="loading-container mt-3">
      <fgbcl-loading></fgbcl-loading>
    </div>
  </ng-template>
</div>
